"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._checksumPick = exports._checksumIgnore = void 0;
exports._checksumIgnore = {
    user: ['_id', 'checksum', 'date_create', 'date_update', 'date_update_unix', 'date_active', 'date_welcome_email', '_email'],
    location: [
        '_id',
        'checksum',
        'checksum_name_address',
        'date_create',
        'date_update',
        'date_update_name_address',
        'date_update_unix',
        'date_cancelled',
        'is_place_found',
        'place',
        'is_phone_matched',
        'vector',
        'date_vector',
    ],
    spotted: ['_id', 'checksum', 'date_create', 'date_update', 'date_update_unix', 'vote', 'view_count', 'comment_count', 'group', 'env_name'],
    vehicle: [
        '_id',
        'checksum',
        'reference',
        'comment_count',
        'view_count',
        'vote',
        'date_create',
        'date_update',
        'date_update_unix',
        'group',
        'env_name',
        'review_score',
        'vector',
        'date_vector',
    ],
    rawVehicle: ['_id', 'inventory_id', 'checksum', 'log', 'date_create', 'is_processed', 'synced'],
};
exports._checksumPick = {
    locationNameAddress: ['name', 'address1', 'zip_code'],
};
